import { EventHandler } from "../../util/event/EventHandler";
import { Logger } from "../../util/log/Logger";
import { BalanceRequest } from "../common/controller/net/request/BalanceRequest";
import { AbstractHandler } from "../core/handler/AbstractHandler";
/**
 * BalanceHandler.ts
 */
export class BalanceHandler extends AbstractHandler {
    constructor(action, scope, refresh = false) {
        super();
        this.eventHandler = new EventHandler(action, scope);
        this.refresh = refresh;
        this.run();
    }
    run() {
        super.run();
        this.getBalance();
    }
    getBalance() {
        let request = new BalanceRequest(this.refresh);
        request.onSuccess(this.handleBalanceSuccess, this);
        request.onFailure(this.handleBalanceFailed, this);
        request.send();
    }
    handleBalanceSuccess(data) {
        let responseData = data;
        this.handleAction(responseData);
    }
    handleBalanceFailed() {
        Logger.forceLog("Balance Request Failed");
    }
    handleAction(result) {
        this.eventHandler.call(result);
        this.destroy();
    }
}
//# sourceMappingURL=BalanceHandler.js.map